<template>
  <aha-modal
    width="60%"
    title=""
    :no-margin-padding="true"
    :visible-overflow="true"
    v-if="video || Object.keys(video).length > 0 "
    :hideHeader="true"
  >
    <div class="p-3">
      <div class="flex flex-row justify-between align-middle pb-1.5 modal-close">
        <aha-icon
          name="arrow-left"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          @click="$emit('back')"
        />
        <aha-icon
          name="close"
          @click="$emit('hide')"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>

      <div class="flex justify-center">
        <iframe
          width="1048.89"
          height="600"
          class="w-full h-full object-cover"
          :src="srcTutorial(video.snippet.resourceId.videoId)"
          frameborder="0"
          allow="accelerometer; autoplady;
           clipboard-write; encrypted-media;
           gyroscope; picture-in-picture;
           web-share"
          allowfullscreen
        >
        </iframe>
      </div>
    </div>
  </aha-modal>
</template>
<script>
export default {
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },

  },
  methods: {
    srcTutorial(videoId) {
      return `https://www.youtube.com/embed/${videoId}?rel=0`
    },
  },

}

</script>
<style  lang="scss" scoped >
iframe{
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
}
.modal-close{
  svg{
    cursor: pointer;
  }
}

</style>
